import Text from '@/atoms/Text/Text'
import cn from 'classnames'
import React from 'react'

function Principles( {backgroundColor} ) {
  const principlesData = [
    {
      content: 'Let the land lead'
    },
    {
      content: 'Adaptation is our only constant'
    },
    {
      content: 'Honor all animals'
    },
    {
      content: 'Celebrate food culture everywhere'
    },
  ]
  return (
    <div className={cn(
      "aaco-story-principles relative py-9", {
        [`bg-${backgroundColor}`]: backgroundColor !== undefined,
      }
    )}>
      <div className="aaco-story-principles-wrapper container my-0 mx-auto flex flex-col gap-y-10">
        <div className="aaco-story-principles-header">
          <Text
            tag="h3"
            style="text-black"
          >
            Our Principles
          </Text>
          <hr className="border-black mt-5 md:mt-8" />
        </div>
        <div className="aaco-story-principles-content grid grid-cols-1 md:grid-cols-4 lg:grid-cols-6 gap-x-16 gap-y-8">
          {/* <div className="aaco-story-principles-content-left col-span-3 md:col-span-2">
            <Text
              tag="h6"
              style="text-black"
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Tempor commodo ullamcorper.
            </Text>
          </div> */}
          <div className="aaco-story-principles-content-right col-span-1 md:col-span-12 grid">
            {principlesData.map((data, index) => (
              <div key={index} className={`aaco-story-principles-detail grid grid-cols-5 md:grid-cols-8 pb-4 md:pb-8 lg:pb-12 border-b-1 border-black ${index !== 0 && "pt-4 md:pt-10"}`}>
                <div className="story-principles-number col-span-1 md:col-span-2 lg:col-span-1 xl:self-center">
                  <h4
                    className="font-heading text-h6-mobile font-h6-mobile md:text-h4 md:font-h4 text-black"
                  >
                    0{index + 1}
                  </h4>
                </div>
                <div className="story-principles-content-detail col-span-4 md:col-span-5 lg:col-span-7 xl:self-center">
                  <h4
                    className="font-heading text-h6-mobile font-h6-mobile md:text-h4 md:font-h4 text-black"
                  >
                    {data.content}
                  </h4>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Principles
